/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import {AvatarDropdown, AvatarName} from './RightContent/AvatarDropdown';
import AuthButton from './AuthButton';
import { renderAdsMetricsSummary } from './AdsMetricsSummary';
import MoneyText from './MoneyText';
import StatusTag from './StatusTag';
import TrendTag from './TrendTag';
import SyncHistoryChart from './SyncHistoryChart';

export {AvatarDropdown, AvatarName, Footer, AuthButton, MoneyText, StatusTag, TrendTag, SyncHistoryChart, renderAdsMetricsSummary};
